import React, { useEffect, useState } from "react";
import { Button, InputNumber, message } from "antd";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import { paramTarifMockData } from "../../utils/navbarUtils";
import axiosInstance from "../../variables/api/axiosInstance";
import { rightsService } from "../../services/rightsService";

// Habilitation requise pour modifier le plafond du bonus (alignée sur le backend).
const RIGHT_MODIF_PLAFOND_BONUS = "HPA088";
// Habilitation requise pour modifier le plafond du bonus « membre du personnel ».
const RIGHT_MODIF_PLAFOND_BONUS_PERSONNEL = "HPA091";

const tarificationParameters = [
  {
    title: "Paramétrage de garanties",
    description:
      "Paramétrer les garanties en définissant pour chacune d'elle la valeur de la prime en fonction des caractéristiques de l'engin et le capital d'indemnisation",
    link: "/garanties",
    button: "Définir une nouvelle garantie",
  },
  {
    title: "Paramétrage de réductions",
    description:
      "Paramétrer les réductions en définissant pour chacune d'elle le taux de réduction, les garanties sur lesquelles elle s'applique",
    link: "/reductions",
    button: "Définir une nouvelle réduction",
  },
  {
    title: "Paramétrage de conversions",
    description:
      "Paramétrer les conversions d'énergie afin de permettre le calcul de la Garantie Responsabilité civile quelque soit la source d'énergie de l'engin",
    link: "/parametres/conversion",
    button: "Définir une nouvelle conversion",
  },
  {
    title: "Paramétrage de catégories",
    description:
      "Paramétrer les différentes catégories d'engins pris en charge par le POOL TPVM-VT GIE",
    link: "/categories",
    button: "Définir une nouvelle catégorie",
  },
  {
    title: "Paramétrage de fractionnement",
    description:
      "Paramétrer les différents fractionnements applicables sur un contrat",
    link: "/parametres/fractionnements",
    button: "Définir un nouveau fractionnement",
  },
  {
    title: "Paramétrage des avenants",
    description:
      "Paramétrer les différents avenants applicables sur un contrat avec les codes.",
    link: "/parametres/avenants",
    button: "Définir un nouvel avenant",
  },
  // {
  //   title: "Paramétrage des carrosseries",
  //   description:
  //     "Paramétrer les différents carrosseries d'engins suivant leur catégorie",
  //   link: "/parametres/carosseries",
  //   button: "Définir une nouvelle carosserie",
  // },
  {
    title: "Carrosseries & Genres par catégorie",
    description:
      "Définir, par catégorie, les carrosseries et genres proposés dans les formulaires d'engins",
    link: "/parametres/engins-parametres",
    button: "Paramétrer carrosseries & genres",
  },
  {
    title: "Paramétrage des usages",
    description:
      "Paramétrer les différents usages d'engins suivant leur catégorie",
    link: "/parametres/usages",
    button: "Définir un nouvel usage",
  },
  {
    title: "Paramétrage des marques",
    description:
      "Paramétrer les différentes marques d'engins suivant leur catégorie",
    link: "/parametres/marques",
    button: "Définir une nouvelle marque",
  },
  {
    title: "Paramétrage des accessoires",
    description:
      "Paramétrer les différents accessoires d'engins suivant leur catégorie",
    link: "/parametres/accessoires",
    button: "Définir des frais d'accessoires",
  },
  {
    title: "Paramétrage des intermédiaires",
    description:
      "Gérer les intermédiaires (apporteurs) et leurs paramètres",
    link: "/intermediaires",
    button: "Gérer les intermédiaires",
  },
  {
    title: "Paramétrage des courtiers",
    description:
      "Gérer les courtiers et leurs paramètres",
    link: "/courtiers",
    button: "Gérer les courtiers",
  },
  {
    title: "Paramétrage des taux de commissions",
    description:
      "Paramétrer les taux de commissions sur les contrats suivant les catégories et les types d'apporteurs",
    link: "/parametres/taux-commissions",
    button: "Définir un taux de commission",
  },
  {
    title: "Paramétrage du numéro de la police",
    description: "Paramétrer le numéro de la police",
    link: "/autre-parametres/numero-police",
    button: "Définir le numéro de la police",
  },
  {
    title: "Paramétrage des taxes",
    description:
      "Paramétrer les différentes taxes suivant les garanties sur lesquelles ils sont applicables",
    link: "/parametres/taxes",
    button: "Définir une taxe",
  },
];

const ParametresTarification = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  // Plafond du bonus éditable (%) — paramètre global, modifiable depuis cet écran
  // (sous habilitation HPA088).
  const [plafondBonus, setPlafondBonus] = useState(30);
  const [savingPlafond, setSavingPlafond] = useState(false);
  const canEditPlafond = rightsService(RIGHT_MODIF_PLAFOND_BONUS);

  // Plafond du bonus « membre du personnel » (%) — paramètre Pool, défaut 50 (HPA091).
  const [plafondBonusPersonnel, setPlafondBonusPersonnel] = useState(50);
  const [savingPlafondPersonnel, setSavingPlafondPersonnel] = useState(false);
  const canEditPlafondPersonnel = rightsService(RIGHT_MODIF_PLAFOND_BONUS_PERSONNEL);

  useEffect(() => {
    axiosInstance.get("/api/parametre/plafond-bonus")
      .then((res) => {
        const v = Number(res.data);
        if (!Number.isNaN(v) && v >= 0) setPlafondBonus(v);
      })
      .catch(() => { /* défaut conservé */ });
    axiosInstance.get("/api/parametre/plafond-bonus-personnel")
      .then((res) => {
        const v = Number(res.data);
        if (!Number.isNaN(v) && v >= 0) setPlafondBonusPersonnel(v);
      })
      .catch(() => { /* défaut conservé */ });
  }, []);

  const savePlafondBonus = () => {
    const v = Number(plafondBonus);
    if (Number.isNaN(v) || v < 0) {
      message.error("Le plafond du bonus doit être un nombre positif.");
      return;
    }
    setSavingPlafond(true);
    axiosInstance.put(`/api/parametre/plafond-bonus/${v}`)
      .then(() => message.success(`Plafond du bonus enregistré : ${v} %`))
      .catch(() => message.error("Erreur lors de l'enregistrement du plafond du bonus."))
      .finally(() => setSavingPlafond(false));
  };

  const savePlafondBonusPersonnel = () => {
    const v = Number(plafondBonusPersonnel);
    if (Number.isNaN(v) || v < 0) {
      message.error("Le plafond du bonus personnel doit être un nombre positif.");
      return;
    }
    setSavingPlafondPersonnel(true);
    axiosInstance.put(`/api/parametre/plafond-bonus-personnel/${v}`)
      .then(() => message.success(`Plafond du bonus personnel enregistré : ${v} %`))
      .catch(() => message.error("Erreur lors de l'enregistrement du plafond du bonus personnel."))
      .finally(() => setSavingPlafondPersonnel(false));
  };

  const renderSearchResults = (results) => {
    return (
      results.map(({ category, items }) => (
        <div key={category} className="px-3 py-2">
          <h6 className="text-muted text-uppercase mb-2">
            {category}
          </h6>
          {items
            .filter((item) =>
              item.name.toLowerCase().includes(searchValue.toLowerCase())
            )
            .map((item, index) => (
              <a
                key={index}
                href={item.url}
                className="dropdown-item d-flex align-items-center gap-2 py-1"
              >
                <i className={`bx ${item.icon} text-muted`}></i>
                <span className="text-truncate">{item.name}</span>
              </a>
            ))}
        </div>
      ))
    );
  }

  useEffect(() => {
    if (searchValue && searchValue?.length > 2) {
      let results = [];
      Object.keys(paramTarifMockData).forEach((key) => {
        const filtered = paramTarifMockData[key].filter((item) =>
          item.name.toLowerCase().includes(searchValue.toLowerCase())
        );
        if (filtered.length) {
          results.push({ category: key, items: filtered });
        }
      });
      setSearchResults(results);
    }
  }, [searchValue]);

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu={"TARIFICATION"} />
        <div className="layout-page">
          <NavBar
            filteredResults={searchResults}
            setFilteredResults={setSearchResults}
            renderSearchResults={renderSearchResults}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row g-4">
                {/* Plafond du bonus — édition en ligne */}
                <div className="col-md-6 col-lg-4">
                  <div className="card h-100 shadow-sm border-0">
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title fw-bold mb-2">Plafond du bonus</h5>
                      <p className="card-text flex-grow-1 text-muted">
                        Taux maximal (%) du bonus éditable manuellement sur un contrat.
                        Au-delà, la saisie est ramenée à ce plafond.
                      </p>
                      <div className="d-flex align-items-center gap-2 mt-2">
                        <InputNumber
                          min={0}
                          max={100}
                          step={1}
                          value={plafondBonus}
                          onChange={(v) => setPlafondBonus(v)}
                          addonAfter="%"
                          style={{ width: 140 }}
                          disabled={!canEditPlafond}
                        />
                        <Button type="primary" loading={savingPlafond} onClick={savePlafondBonus} disabled={!canEditPlafond}>
                          Enregistrer
                        </Button>
                      </div>
                      {!canEditPlafond && (
                        <small className="text-muted mt-2">
                          Modification réservée au Pool. Consultation seule.
                        </small>
                      )}
                    </div>
                  </div>
                </div>

                {/* Plafond du bonus « membre du personnel » — édition en ligne */}
                <div className="col-md-6 col-lg-4">
                  <div className="card h-100 shadow-sm border-0">
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title fw-bold mb-2">Plafond du bonus membre du personnel</h5>
                      <p className="card-text flex-grow-1 text-muted">
                        Taux maximal (%) du bonus appliqué aux contrats marqués « membre du
                        personnel ». Pris par défaut à ce taux ; éditable à la baisse à la production.
                      </p>
                      <div className="d-flex align-items-center gap-2 mt-2">
                        <InputNumber
                          min={0}
                          max={100}
                          step={1}
                          value={plafondBonusPersonnel}
                          onChange={(v) => setPlafondBonusPersonnel(v)}
                          addonAfter="%"
                          style={{ width: 140 }}
                          disabled={!canEditPlafondPersonnel}
                        />
                        <Button type="primary" loading={savingPlafondPersonnel} onClick={savePlafondBonusPersonnel} disabled={!canEditPlafondPersonnel}>
                          Enregistrer
                        </Button>
                      </div>
                      {!canEditPlafondPersonnel && (
                        <small className="text-muted mt-2">
                          Modification réservée au Pool. Consultation seule.
                        </small>
                      )}
                    </div>
                  </div>
                </div>

                {tarificationParameters.map(({ title, description, link, button }) => (
                  <div key={title} className="col-md-6 col-lg-4">
                    <div className="card h-100 shadow-sm border-0">
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title fw-bold mb-2">{title}</h5>
                        <p className="card-text flex-grow-1 text-muted">{description}</p>
                        <a href={link} className="btn btn-primary mt-2">
                          {button}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <Footer />
            <div className="content-backdrop fade"></div>
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default ParametresTarification;
